import { useNavigate } from 'react-router-dom';
import { AngleLeftIcon, AngleRightIcon } from '../../helpers/icons';
import { useAuth, useSidebarCollapse, useUserDetails } from '../../zustand';
import { Avatar } from '../Avatar';
import { Button } from '../Button';
import { Dropdown } from '../Dropdown';
import PendingCustomersIcon from './components/PendingCustomersIcon';
import PendingExtensionsIcon from './components/PendingExtensionsIcon';
import NotificationBell from './components/NotificationBell';
import {
  ADMIN,
  PROVIDER,
  RESELLER,
  SUB_PROVIDER,
} from '../../helpers/globalConstants';

export default function Header() {
  const navigate = useNavigate();
  const { name } = useUserDetails((s) => s.userDetails || {});
  const { role } = useAuth((s) => s);
  const { toggleSidebar, openSidebar } = useSidebarCollapse((s) => s);
  return (
    <header className="w--full p--sm bg--white h-min--50 d--flex align-items--center justify-content--between box-shadow--xs-bottom">
      <div className="w--full gap--sm d--flex text--primary c--pointer">
        <Button
          btnClasses="btn gap--sm w-max--24 h-max--24 h-min--24"
          type="button"
          size="xs"
          variant="primary"
          color="white"
          rounded="md"
          // icon={<AngleRightIcon width={20} />}
          icon={
            !openSidebar ? (
              <AngleLeftIcon width={20} />
            ) : (
              <AngleRightIcon width={20} />
            )
          }
          onClick={() => toggleSidebar()}
        ></Button>
      </div>

      {/* A reseller runs its own system, so it gets the staff toolbar too. The
          other branch is the customer one, and its My Account link goes to a
          customer-only route. */}
      {[PROVIDER, SUB_PROVIDER, RESELLER, ADMIN].includes(role) ? (
        <div className="w--full d--flex justify-content--end align-items--center gap--md">
          {ADMIN !== role && <PendingExtensionsIcon />}
          {ADMIN !== role && <PendingCustomersIcon />}
          <NotificationBell />
          <div className="d--flex align-items--center font--sm font--600 gap--sm text--black">
            <Avatar firstname={name ?? ''} />
            {name} &nbsp;
          </div>
        </div>
      ) : (
        <div className="w--full d--flex justify-content--end align-items--center gap--md">
          <Dropdown
            options={[
              {
                label: 'My Account',
                cb: () => navigate('my-account/account-information'),
              },
            ]}
          >
            <div className="d--flex align-items--center font--sm font--600 gap--sm text--black">
              <Avatar firstname={name ?? ''} />
              {name} &nbsp;
            </div>
          </Dropdown>
        </div>
      )}
    </header>
  );
}
